module.exports = __webpack_public_path__ + "images/26514674bdd909a488155b53ff60c101.png";